import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: number;
}

export const StatCard: React.FC<StatCardProps> = ({ title, value, icon, trend = 0 }) => {
  const getTrendIcon = () => {
    if (trend > 0) return <ArrowUpRight className="text-green-500" size={20} />;
    if (trend < 0) return <ArrowDownRight className="text-red-500" size={20} />;
    return <Minus className="text-gray-500" size={20} />;
  };

  const getTrendColor = () => {
    if (trend > 0) return 'text-green-500';
    if (trend < 0) return 'text-red-500';
    return 'text-gray-500';
  };

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="bg-white rounded-lg shadow-sm p-6"
    >
      <div className="flex items-center justify-between mb-4">
        {icon}
        {getTrendIcon()}
      </div>
      <h3 className="text-gray-600 text-sm mb-1">{title}</h3>
      <div className="flex items-baseline gap-2">
        <span className="text-2xl font-bold">{value}</span>
        {trend !== 0 && (
          <span className={`text-sm ${getTrendColor()}`}>
            {trend > 0 ? '+' : ''}{trend}%
          </span>
        )}
      </div>
    </motion.div>
  );
};